import TextTheme from "../../General/Text/TextTheme";
import Upload from "../../../site_media/images/Settings_Camera.png";
import * as CONSTANT from "../../../constants/text";
import Modal from "../../Spotlight/Album/UploadModalButton"
import React from "react";
import AxiosConfig from "axiosConfig";
import {validImages, validVideo} from "../../Spotlight/Album/ValidFiles";

class CreationUpload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            email: "",
            date: null,
            media: null,
            file_type: "",
            exten:"",
            media_type: "",
            user_access: "",
            form_dat: new FormData(),
            vis: false,
            preview: null,
            success: false,
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.showPreview = this.showPreview.bind(this);
    }

    toggleModal = () => {
        if (this.setState.vis) {
            this.forceUpdate();
        }
        this.setState({vis: !this.state.vis});
    }

    uploadPreview = (event) => {
        const fileType = event.target.files[0].type;
        if (fileType.includes("video")){
            this.setState({
                type:"video",
                vis:true
            })
        }
        else{
            this.setState({
                type:"image"
            })
            try {
                let form_data = new FormData();
                form_data.append("media", event.target.files[0]);
                form_data.append("username", '');
                form_data.append("file_type", event.target.files[0].type);
                form_data.append("media_type", this.readMediaType(event.target.files[0].name));
                form_data.append("user_access", 'P');
                form_data.append("media_source", 'U');
                form_data.append("belongs_in", 'A');
                this.setState(
                    {
                        preview: URL.createObjectURL(event.target.files[0]),
                        file_type: this.readMediaType(event.target.files[0].name),
                        media: form_data.get("media"),
                        user_access: form_data.get("user_access"),
                        form_dat: form_data,
                    });
                if (this.checkFileSize(event.target.files[0]))
                {
                    this.toggleModal();
                    this.getPop();
                }
                else {
                    console.log("File Too Large");
                }
            } catch
                (exception) {
                console.log("User canceled Upload.")
            }
        }
    }

    checkFileSize(file){
        let type = "";
        type = this.readMediaType(file.name);
        const maxVideo = 1024*1024*500; //500mb
        const maxImage = 1024*1024*30; //30mb
        let size = 0;
        size = file.size;
        if (type === "I" && size <= maxImage) {
            return true;
        }
        else if (type === "V" && size <= maxVideo){
            return true;
        }
        else {
            return false;
        }
    }

    getExtension(file){
        let ext = "";
        ext = file.split('.').pop();
        return ext;
    }

    readMediaType(file) {
        let ext = "";
        ext = this.getExtension(file);
        if (validImages().indexOf(ext) > -1) {
            this.setState({
                media_type:'I',
                exten:ext});
            return 'I';
        }else if (validVideo().indexOf(ext) > -1) {
            this.setState({
                media_type: 'V',
                exten:ext});
            return 'V';
        }
        else
        {
            return "";
        }
    }

    renderFileUploadMessage = () => {
        let messageArray = [
                <div className="upload-status success">Upload Successful</div>,
                <div className="upload-status error">Incorrect File Type</div>,
                <div className="upload-status none">""</div>],

            currentIndex = 2;

        let file = this.state.media_type;
        if (file === 'I' || file === 'V') {
            currentIndex = 0;
        } else if (file === undefined || file === '' || file === null) {
            currentIndex = 2;
        } else {
            currentIndex = 1;
        }
        return messageArray[currentIndex];
    }

    creationSuiteUpload = () => {
        let album_form = this.state.form_dat;
        album_form.append("belongs_in",'C');
        
        AxiosConfig.post('mediaManager/media/', album_form, {//HTPP POST Request
            headers: {
                "content-type": "multipart/form-data",
            },
        }).then(res => {
            this.renderFileUploadMessage("succ");
        }).catch(err => {
            this.renderFileUploadMessage("err");
        });
        this.setState({preview: null});

    }

    uploadMedia = () => {
        let album_form = this.state.form_dat;
        album_form.append("belongs_in",'A');
        try {
            AxiosConfig.post('mediaManager/media/', album_form, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }).then(res => {
                this.renderFileUploadMessage("succ");
                this.setState({preview: null, success:true});
                this.props.refresh();
                this.props.uploadToggle();
            }).catch(err => {
                this.renderFileUploadMessage("err");
            });
        } catch
            (exception) {
            console.log("User canceled Upload.")
        }
    }

    showPreview = () => {
        let disp = this.state.media_type;
        let med = this.state.preview;
        if (disp === "I"){
            return (
                <img className="preview-img d-flex" src={med}/>
            );
        }else{
            return(
                <video className="preview-vid d-flex" width="750" height="500">
                    <source src = {med} type="video/mp4" />
                </video>
            );}
    }

    getPop= () => {
        if (this.state.vis === true) {
            return (
                <>
                    {
                    this.state.type =="video"?
                    
                            <div className="upload-pop-main-one d-flex">
                                <div className="pop-buttons d-flex">
                                        <div className="upload-text-pop-cs">
                                            <TextTheme message={"You can only play with images inside Creator Studio"}
                                                className="text_dark_bright_blue text_smed text_bold center" />
                                        </div>
                                </div>
                            </div> :
                            <div className="upload-pop-frame d-flex">
                                <div className="preview-zone d-flex">
                                    {this.showPreview()}
                                </div>
                                <div className="pop-buttons d-flex">
                                    <label type="button=" className="upload-create" onClick={this.creationSuiteUpload.bind(this)}>
                                        <img className="upload-button-pop-cs" src={Upload} alt="Painting" />
                                        <div className="upload-text-pop-cs">
                                            <TextTheme message={CONSTANT.UPLOAD_IMAGE}
                                                className="text_dark_bright_blue text_smed text_bold center" />
                                        </div>
                                    </label>
                                </div>
                            </div>
                }
                </>
                
                
            )}
        else {
            return null;
        }
    }

    render(){
        return (
            <div className = "upload-creation" >
                <Modal show={this.state.vis} handleClose={this.toggleModal} type={this.state.type}>
                    {this.getPop()}
                </Modal>
                <label htmlFor="media-up" className = "upload-upload-creation">
                    <input
                        type = "file"
                        name = "media"
                        id = "media-up"
                        accept = ".png, .jpeg, .jpg, video/*"
                        style = {{display: "none"}}
                        onChange = {this.uploadPreview.bind(this)}
                    />
                    <img className= "upload-button" src = {Upload} alt = "Camera"/>
                    <div className = "upload-text">
                        <TextTheme message={CONSTANT.UPLOAD_IMAGE}
                                   className="text_dark_bright_blue text_smed text_bold center"/>
                    </div>
                </label>
                {this.renderFileUploadMessage()}
            </div>
        )}
}

export default CreationUpload;
